module.exports = __webpack_public_path__ + "static/media/6.19_preview.05f819d3.png";